// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"uom-codetable-list-items__visuallyhidden--orAEm","focusable":"uom-codetable-list-items__focusable--mpIYP","deleting":"uom-codetable-list-items__deleting--NE6fF"};